import React from "react";
import { Spin } from "antd";
import { BsFillFilePdfFill } from "react-icons/bs";

const PDFDownloadButton = ({ onClick, loading, label = '', disabled }) => {
    const handleClick = (e) => {
        e.preventDefault(); // Prevent form submission
        onClick();
    };
    return (
        <button
            disabled={disabled || loading}
            onClick={handleClick}
            className={`px-5 py-2 text-sm flex items-center justify-center gap-2 border rounded-lg transition-all duration-300 font-medium whitespace-nowrap
        ${disabled
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-[#A82424] hover:scale-105 text-white'
                }`}
        >
            <BsFillFilePdfFill className={`text-lg ${disabled ? 'text-gray-600' : 'text-white'}`} />
            {label} Download PDF {loading ? <Spin /> : null}
        </button>
    );
};

export default PDFDownloadButton;